import { requisitionConfirmationAddressesStyles } from "@insite/content-library/Widgets/RequisitionConfirmation/RequisitionConfirmationAddresses";
import { css } from "styled-components";

Object.assign(requisitionConfirmationAddressesStyles, {
    ...requisitionConfirmationAddressesStyles,
    shippingAddressTitle: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
    billingAddressTitle: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
});
